import { PublicHolidaysByYearsClient } from "../../../../../../Wrap/Api/Common/PublicHolidaysByYears";
import { PublicHoliday } from "../../../../../../Wrap/Models/Domains/BusinessDays/PublicHoliday";

export class PublicHolidaysAction {
    public static getPublicHolidaysByYear(year: number, callback: (publicHolidays: PublicHoliday[]) => void) {
        const client = new PublicHolidaysByYearsClient();
        
        client.get([year - 1, year, year + 1]).onSuccess((publicHolidays: PublicHoliday[]) => {
            callback(publicHolidays);
        });
    }
}